// Button behavior: position-aware hover, "scroll to the product buy button", copy a code, and equal widths for buttons
// that sit together (side by side or stacked) in a content column.
(() => {
  // Position aware: the fill starts where the pointer enters the button.
  document.addEventListener('pointerover', (event) => {
    const button = event.target.closest?.('.button[data-animation="position_aware"]');
    if (!button || button.contains(event.relatedTarget)) return;
    const box = button.getBoundingClientRect();
    button.style.setProperty('--pointer-x', `${((event.clientX - box.left) / box.width) * 100}%`);
    button.style.setProperty('--pointer-y', `${((event.clientY - box.top) / box.height) * 100}%`);
  });

  // Add to cart buttons of product cards and Button blocks for other products are plain buttons that submit their form
  // (data-submit-form): bundle apps (Amose) take every submit button in an add to cart form for the page's own buy
  // button and would add their bundle instead.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-submit-form]');
    if (!button || button.disabled || !button.form) return;
    event.preventDefault();
    button.form.requestSubmit();
  });

  // Copy a discount code, then show the "copied" label for a moment.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-copy-code]');
    if (!button) return;
    try { await navigator.clipboard.writeText(button.dataset.copyCode); } catch (error) { return; }
    const label = button.querySelector('.button__label');
    if (!label || !button.dataset.copiedLabel) return;
    clearTimeout(button.copyTimer);
    // A label with a [data-copy-text] part (Discount coupon) changes only that text; data-copied lets its CSS swap the icon.
    const part = label.querySelector('[data-copy-text]') || label;
    // keep the markup to put back afterwards
    button.originalLabel ??= part.innerHTML;
    part.textContent = button.dataset.copiedLabel;
    button.setAttribute('data-copied', '');
    button.copyTimer = setTimeout(() => { part.innerHTML = button.originalLabel; button.removeAttribute('data-copied'); }, 2000);
  });

  // Scroll to the product's buy button (the main add-to-cart on the page). Scroll to an ID: assets/anchor.js.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-scroll-to-buy]');
    if (!trigger) return;
    event.preventDefault();
    // only a product's own buy buttons (product page / featured product), never a product card's quick-add form
    const target = [...document.querySelectorAll('.buy-buttons__form')].find((form) => form.offsetParent);
    if (!target) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  });

  // Buttons that sit together in a .block-flow column (only flow breaks between them) all get the width of the
  // widest one, so a pair like Shop now / Learn more always matches. Full-width buttons are left alone.
  const equalize = (root = document) => {
    root.querySelectorAll('.block-flow').forEach((flow) => {
      const groups = [];
      let group = [];
      [...flow.children].forEach((child) => {
        if (child.classList.contains('button-block')) group.push(child);
        else if (!child.classList.contains('flow-break')) { if (group.length) groups.push(group); group = []; }
      });
      if (group.length) groups.push(group);
      groups.filter((g) => g.length > 1).forEach((g) => {
        const buttons = g.map((block) => block.querySelector('.button')).filter(Boolean);
        buttons.forEach((button) => { button.style.minWidth = ''; });
        const free = buttons.filter((button) => button.getBoundingClientRect().width < button.parentElement.closest('.block-flow').getBoundingClientRect().width - 1);
        const widest = Math.max(0, ...free.map((button) => button.getBoundingClientRect().width));
        free.forEach((button) => { button.style.minWidth = `${Math.ceil(widest)}px`; });
      });
    });
  };
  const run = () => equalize();
  run();
  document.fonts?.ready.then(run);
  let timer;
  window.addEventListener('resize', () => { clearTimeout(timer); timer = setTimeout(run, 150); });
  document.addEventListener('shopify:section:load', (event) => equalize(event.target));
})();
